__turbopack_context__.v({
  "active": "results-game-module-sass-module__VcnESW__active",
  "sportId-1": "results-game-module-sass-module__VcnESW__sportId-1",
  "sportId-109": "results-game-module-sass-module__VcnESW__sportId-109",
  "sportId-110": "results-game-module-sass-module__VcnESW__sportId-110",
  "sportId-111": "results-game-module-sass-module__VcnESW__sportId-111",
  "sportId-118": "results-game-module-sass-module__VcnESW__sportId-118",
  "sportId-121": "results-game-module-sass-module__VcnESW__sportId-121",
  "sportId-bc-1": "results-game-module-sass-module__VcnESW__sportId-bc-1",
  "sportId-bc-140": "results-game-module-sass-module__VcnESW__sportId-bc-140",
  "sportId-bc-208": "results-game-module-sass-module__VcnESW__sportId-bc-208",
  "sportId-bc-215": "results-game-module-sass-module__VcnESW__sportId-bc-215",
  "sportId-bc-269": "results-game-module-sass-module__VcnESW__sportId-bc-269",
  "sportId-bc-270": "results-game-module-sass-module__VcnESW__sportId-bc-270",
  "sportId-bc-74": "results-game-module-sass-module__VcnESW__sportId-bc-74",
  "sportId-bc-75": "results-game-module-sass-module__VcnESW__sportId-bc-75",
  "sportId-bc-76": "results-game-module-sass-module__VcnESW__sportId-bc-76",
  "sportId-bc-77": "results-game-module-sass-module__VcnESW__sportId-bc-77",
  "sportId-bc-80": "results-game-module-sass-module__VcnESW__sportId-bc-80",
  "sportResultsGame": "results-game-module-sass-module__VcnESW__sportResultsGame",
  "sportResultsGameTeams": "results-game-module-sass-module__VcnESW__sportResultsGameTeams",
  "sportResultsGameTime": "results-game-module-sass-module__VcnESW__sportResultsGameTime",
});
